import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { HelpMenuComponent } from '../../help-menu';
import { LevelBadgeModule } from '../../level-badge/level-badge.module';
import { MenuModule } from '../fec-menu/menu.module';
import { NavProfileComponent } from './nav-profile.component';
import { NavigationComponent } from './navigation.component';

@NgModule({
  imports: [
    CommonModule,
    MenuModule,
    MatIconModule,
    MatMenuModule,
    MatTooltipModule,
    LevelBadgeModule,
    HelpMenuComponent,
  ],
  declarations: [NavigationComponent, NavProfileComponent],
  exports: [NavigationComponent],
  providers: [],
})
export class NavigationModule {}
